export interface CheckableProps {
    name: string;
    value?: string;
    label?: string;
    description?: string;
    error?: string | boolean;
    checked?: boolean;
    disabled?: boolean;
    classes?: string;
    attrs?: Record<string, string>;
    inputType?: InputType;
    group?: string;
}

export enum InputType {
    Checkbox = 'checkbox',
    Radio = 'radio',
}
